module.exports = __webpack_public_path__ + "img/undraw_personal_email_t7nw.999a0d94.svg";